import { _ } from "../../core/polyglot/polyglot.js";
import AbstractAgencyBillingStatus from "./AbstractAgencyBillingStatus.js";

let instance;

/**
 * An agency with this status isn't billed because its billing status
 * is unspecified. This agency is most probably for testing only.
 */
export default class UnspecifiedAgencyBillingStatus extends AbstractAgencyBillingStatus {
	label() {
		return _("Unknown status");
	}

	static getType() {
		return "Unspecified";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
